<template>
  <div>
    <el-form label-position="right">
      <el-row>
        <el-col :span="12">
          <el-form-item>
            <p>选择电梯</p>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <el-select
              v-model="liftKeyword"
              clearable
              filterable
              remote
              size="mini"
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              @change="handlerLiftSearch"
              @clear="handlerClear">
              <el-option
                v-for="item in liftSearchOptions"
                :key="item.code"
                :label="item.name"
                :value="item.code">
                <span>{{item.name}}</span>
                <span class="project_option" v-if="item.level == 1">项目</span>
                <span class="lift_option" v-if="item.level == 2">电梯</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="selectAll" v-if="projectList && projectList.length > 0">
      <el-checkbox @change="selectAll" :value="selectedAll">全选</el-checkbox>
    </div>
    <div class="main_panel">
      <el-tree
        v-if="defaultProps"
        :show-checkbox="canCheck"
        node-key="liftId"
        :data="projectLevel"
        :props="defaultProps"
        :default-checked-keys="defaultList"
        :default-expanded-keys="defaultList"
        ref="tree"
        @check="handleCheckChange">
      </el-tree>
    </div>
  </div>
</template>

<script>
  // import {
  //   getProjectOrLiftListData,
  // } from '../request.js';
  export default {
    data() {
      return {
        liftKeyword: null,
        liftSearchOptions: [],
        defaultProps: {
          label: 'name',
          children: 'liftList'
        },
        selectLifts: [],
        selectedAll: true,
        defaultList:[]
      };
    },
    props: {
      unitId: {
        require: true
      },
      departmentId: {
        require: true
      },
      projectList: {
        require: true,
        default: function() {
          return []
        }
      },
      defaultProjectList: {
        require: false,
        default: function() {
          return []
        }
      },
      canCheck: {
        default: true
      }
    },
    computed: {
      projectLevel: function() {
        this.liftListLengths = 0;
        if (this.projectList && this.projectList.length) {
          this.projectList.map(item => {
            item.name = `${item.projectName} (${item.liftList.length})`;
            item.liftId = -item.projectId
            item.liftList.map(lift => {
              lift.name = lift.liftName;
            })
            this.liftListLengths += item.liftList.length;
          });
          return this.projectList;
        }
        return [];
      }
    },
    watch: {
      projectList: function(value) {
        if (value) {
          this.$nextTick(() => {
            this.isSelectAll();
          });
        }
      },
      defaultProjectList: function(val) {
        if (val) {
          this.$nextTick(()=> {
            this.defaultList = [...val]
          })
        }
      }
    },
    methods: {
      // 每次选择发送电梯数组
      handleCheckChange(data, node) {
        if (!this.canCheck) {
          return;
        }
        if (!this.isCheck) {
          this.selectedAll = false;
        }
        if (node && node.checkedNodes && node.checkedNodes.length && node.checkedNodes.length < this.liftListLengths) {
          this.selectedAll = false;
        } else {
          this.selectedAll = true;
        }
// this.selectLifts = [];
        // if (node && node.checkedNodes && node.checkedNodes.length) {
        //   this.selectLifts = node.checkedNodes.map(item => item.registerCode);
        // }
        this.emitSelect();        
      },
      // 返回选择内容
      emitSelect() {
        const checkResult = this.$refs.tree.getCheckedNodes(false, true);
        this.selectLifts = [];
        const check = {
          checkPeojectName: [],
          checkPeojectId: [],
        }
        checkResult.forEach((item) => {
          if (!item.liftId || item.liftId < 0) {
            check.checkPeojectName.push(item.projectName);
            check.checkPeojectId.push(item.projectId);
          } else {
            this.selectLifts.push(item.liftId);
          }
        });
        this.$emit('lifts', this.selectLifts, check);
      },
      // 搜索
      async remoteMethod(query) {
        this.liftSearchOptions = await getProjectOrLiftListData({
          keyword: query,
          departmentId: this.departmentId,
          unitMasterId: this.unitId
        });
      },
      // 选择搜索结果
      handlerLiftSearch() {
        for (let i = 0, len = this.liftSearchOptions.length; i < len; i += 1) {
          if (this.liftSearchOptions[i].code === this.liftKeyword) {
            this.$refs.tree.filter(this.liftSearchOptions[i]);
            break;
          }
        }
      },
      // 清除搜索
      handlerClear() {
        this.$refs.tree.filter();
      },
      // 全选项目
      selectAll() {
        this.selectedAll = !this.selectedAll;
        if (this.selectedAll) {
          let _arr = [];
          if (this.projectLevel && this.projectLevel.length) {
            this.projectLevel.forEach(item => {
              _arr.push(item.liftId);
            });
          }
          this.$refs.tree.setCheckedKeys(_arr);
        } else {
          this.$refs.tree.setCheckedKeys([]);
        }
        this.emitSelect();
      },
      isSelectAll() {
        if (this.defaultList.length === this.liftListLengths) {
          this.selectedAll = true
        } else {
          this.selectedAll = false
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .main_panel {
    height: 300px;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/UserManagement/components/LiftInfo.vue